/* Aesthesy option behaviour — the size chart button and the size chart's own
   size row. (The size dropdown code below is unused since sizes became pills.)

   The picker markup is complete from the server (snippets/aes-variant-picker):
   legends, the collapsed size trigger, the option rows and the frame swatch
   strip with its images. Nothing here builds or moves DOM, so there is no
   flash of the vendor layout before "decoration" — this only opens and closes
   the size list, keeps the trigger's label in step, and wires Size Chart. */
(() => {
  if (window.__aesOptionsBooted) return;
  window.__aesOptionsBooted = true;

  const close = (t) => {
    t.setAttribute('aria-expanded', 'false');
    t.closest('fieldset')?.removeAttribute('data-open');
  };

  // Bound once for the page: outside-click and Escape close any open list.
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-aes-trigger][aria-expanded="true"]').forEach((t) => {
      const fs = t.closest('fieldset');
      if (fs && !fs.contains(e.target)) close(t);
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('[data-aes-trigger][aria-expanded="true"]').forEach(close);
  });

  const bind = (fs) => {
    if (fs.dataset.aesBound) return;
    fs.dataset.aesBound = '1';
    const trigger = fs.querySelector('[data-aes-trigger]');
    if (trigger) {
      const val = trigger.querySelector('[data-aes-trigger-value]');
      trigger.addEventListener('click', () => {
        const open = fs.hasAttribute('data-open');
        fs.toggleAttribute('data-open', !open);
        trigger.setAttribute('aria-expanded', String(!open));
      });
      fs.addEventListener('change', (e) => {
        if (!e.target.matches('input')) return;
        if (val) val.textContent = e.target.value;
        close(trigger);
      });
    }
    fs.querySelector('[data-aes-szc-open]')?.addEventListener('click', () => {
      const szc = document.querySelector('[data-aes-szc]');
      if (!szc) return;
      // The room photo is lazy so it costs nothing until asked for, but Chrome
      // never starts a lazy image inside a modal dialog. Opening is the ask.
      szc.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      szc.showModal();
      szc.querySelector('.aes-szc__pill[aria-pressed="true"]')?.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
  };

  // Size chart: the size row and the frame drawn to scale on the room photo.
  // The PDP picker stays the one source of truth: a tap here checks the
  // matching PDP radio and fires its change, and that change is what redraws
  // this dialog, so the two can never disagree.
  const bindChart = (szc) => {
    if (szc.dataset.aesBoundChart) return;
    szc.dataset.aesBoundChart = '1';
    const pills = [...szc.querySelectorAll('[data-aes-szc-size]')];
    const scene = szc.querySelector('[data-aes-szc-scene]');
    const frame = scene?.querySelector('[data-aes-szc-frame]');
    const label = frame?.querySelector('span');
    const scope = szc.closest('.shopify-section') || document;
    const SIZE = 'variant-selects[data-primary] .aes-opt__group--size input';

    // Scale, as % of the photo's width per inch. True to the room when the
    // product's biggest size fits the wall above the sideboard (8% clear at
    // the top and sides); otherwise the biggest is fitted and the rest scale
    // down from it, so sizes always stay true to EACH OTHER.
    const aspect = parseFloat(scene?.dataset.aspect) || 1; // photo width / height
    const rest = parseFloat(scene?.dataset.rest) || 74;    // % down the photo
    const inches = (p, k) => parseFloat(p.dataset[k]) || 0;
    const maxW = Math.max(0, ...pills.map((p) => inches(p, 'wIn')));
    const maxH = Math.max(0, ...pills.map((p) => inches(p, 'hIn')));
    const fits = [100 / (parseFloat(scene?.dataset.wallIn) || 61)];
    if (maxW) fits.push((100 - 2 * 8) / maxW);
    if (maxH) fits.push((rest - 8) / (maxH * aspect));
    const perIn = Math.min(...fits);
    if (frame) frame.style.bottom = 100 - rest + '%';

    const show = (value) => {
      const pill = pills.find((p) => p.dataset.aesSzcSize === value);
      pills.forEach((p) => p.setAttribute('aria-pressed', String(p === pill)));
      if (!frame) return;
      frame.hidden = !pill || !inches(pill, 'wIn');
      if (frame.hidden) return;
      frame.style.width = inches(pill, 'wIn') * perIn + '%';
      frame.style.height = inches(pill, 'hIn') * perIn * aspect + '%';
      frame.toggleAttribute('data-round', pill.hasAttribute('data-round'));
      if (label) label.textContent = value;
    };
    show(szc.querySelector('[data-aes-szc-size][aria-pressed="true"]')?.dataset.aesSzcSize);

    szc.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-aes-szc-size]');
      if (!pill) return;
      const value = pill.dataset.aesSzcSize;
      const input = [...scope.querySelectorAll(SIZE)].find((i) => i.value === value);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        show(value);
      }
    });
    scope.addEventListener('change', (e) => {
      if (e.target.matches(SIZE)) show(e.target.value);
    });
  };

  const boot = () => {
    document.querySelectorAll('.aes-opt__group').forEach(bind);
    document.querySelectorAll('[data-aes-szc]').forEach(bindChart);
  };
  boot();
  document.addEventListener('aes:content-added', boot);
  document.addEventListener('shopify:section:load', boot);
})();
